import { countryCodes, defaultPrefix } from 'all-in-one-shared-api';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils';

const { Option } = Select;

interface MobileNumberPrefix {
  defaultValue?: string;
  handleChange?: (value: string) => void;
}

const MobileNumberPrefix = ({ defaultValue, handleChange }: MobileNumberPrefix) => {
  const { i18n } = useTranslation();

  return (
    <Select
      defaultValue={defaultValue ?? defaultPrefix}
      dropdownMatchSelectWidth={false}
      optionLabelProp="label"
      onChange={handleChange}
    >
      {countryCodes.map(({ label, zh_label, value }) => (
        // Note(Andy Chow): the 'value' of some items in countryCodes is the same => use label as key instead
        <Option key={`${value} ${label}`} value={value} label={value}>
          {value} {isLocaleEnglish(i18n.language) ? label : zh_label}
        </Option>
      ))}
    </Select>
  );
};

export default MobileNumberPrefix;
